import { render, staticRenderFns } from "./electronicFence.vue?vue&type=template&id=5149bcc2&scoped=true&"
import script from "./electronicFence.vue?vue&type=script&lang=js&"
export * from "./electronicFence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5149bcc2",
  null
  
)

export default component.exports